import React, { Fragment } from "react";

const MentorProfileApprovals = () => {
  return (
    <Fragment>
      <div className="online-users-profile">
        <div className="online-title-container-alt">
          <div className="border-alt red">
            <p className="online-title-alt red">
              <i className="fas fa-file-signature red mr-5"></i>Approvals
            </p>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MentorProfileApprovals;
